import styled from 'styled-components';

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
  gap: 0.9375rem;

  @media (max-width: 768px) {
    gap: 0.625rem;
  }
`;

export default StatsGrid;
